export default {
      id: "ic-nav-search-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic-nav-search-usage",
      toString: function () {
        return this.url;
      }
    }